import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ORDER_CORE_FEATURE, OrderHistoryList } from '@spartacus/order/root';
import { Injectable } from '@angular/core';
import { CustomConsignment, CustomOrder, OrderInvoiceFile, RefundReason, ReturnEntry } from '../models';
import { OrderStatusEnum, SaveOrderProductsEnum } from '../enums';

export function orderFacadeFactory() {
  return facadeFactory({
    facade: OrderFacade,
    feature: ORDER_CORE_FEATURE,
    methods: [
      'getOrderHistoryList',
      'updateOrderSaveOrderProducts',
      'getOrderDetails',
      'getOrderReturnConsignment',
      'getOrderReturnReasons',
      'submitOrderReturn',
      'getInvoiceOrder'
    ],
    async: true
  });
}

@Injectable({
  providedIn: 'root',
  useFactory: orderFacadeFactory
})
export abstract class OrderFacade {
  abstract getOrderHistoryList(
    pageSize: number,
    currentPage?: number,
    sort?: string,
    statuses?: OrderStatusEnum[]
  ): Observable<OrderHistoryList>;

  abstract updateOrderSaveOrderProducts(orderCode: string, status: SaveOrderProductsEnum): Observable<void>;

  abstract getOrderDetails(orderCode: string): Observable<CustomOrder>;

  abstract getOrderReturnConsignment(orderCode: string, consignmentCode: string): Observable<CustomConsignment>;

  abstract getOrderReturnReasons(): Observable<RefundReason[]>;

  abstract submitOrderReturn(
    orderCode: string,
    consignmentCode: string,
    returnEntries: ReturnEntry[]
  ): Observable<CustomConsignment>;

  abstract getInvoiceOrder(orderCode: string): Observable<OrderInvoiceFile>;
}
